import React from "react";
import ProjectCard from "./ProjectCard/ProjectCard";
import "./Projects.scss";
import { Context } from "../../App";
const Projects = () => {
  return (
    <div className="projects container" id="projects">
      <h6 className="heading" id="features">
        Projects
      </h6>
      <div className="row">
        <Context.Consumer>
          {(project_arr) => {
            return (
              <>
                {project_arr.map((el, index) => (
                  <ProjectCard
                    title={el.name}
                    image={el.banner}
                    link={`/project/${index}`}
                  />
                ))}
              </>
            );
          }}
        </Context.Consumer>
      </div>
    </div>
  );
};

export default Projects;
